/**
 * Convert allowlisted site backup values to Create Backup form state.
 *
 * `backup_site_name` is deliberately not mapped here: the Create form's Site
 * Name control is a topology multi-select keyed by site_id, not by the
 * site's display name the agent carries, and the field catalogue declares
 * no prefillable surface for it (`fields.json` lists no `surfaces` entry for
 * `backup_site_name`) - so the site the user named is left for them to
 * (re)select rather than guessed at.
 *
 * @param {object} values canonical agent values
 * @return {object} form patch
 */
export function mapSiteBackupPrefill(values = {}) {
	const patch = {};
	if (typeof values.backup_name === 'string' && values.backup_name.trim()) {
		patch.backupName = values.backup_name.trim();
	}
	if (
		typeof values.backup_description === 'string' &&
		values.backup_description.trim()
	) {
		patch.description = values.backup_description.trim();
	}
	return patch;
}
